module.exports = __webpack_public_path__ + "img/docRes_f.a95802b8.png";